/**
 * PROinfra Shared API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { HttpHeaders }                                       from '@angular/common/http';

import { Observable }                                        from 'rxjs';

import { Bridge } from '../model/models';


import { Configuration }                                     from '../configuration';



export interface BridgeServiceInterface {
    defaultHeaders: HttpHeaders;
    configuration: Configuration;

    /**
     * Returns a bridge and their components to a given ID
     * 
     * @param structureId ID of structure to return
     */
    getBridgeInformationById(structureId: number, extraHttpRequestParams?: any): Observable<Bridge>;

}
